export const sanitizeParam = (value, { normalize, validate }) => {
  if (typeof value !== 'string') return null;

  let v;

  try {
    v = decodeURIComponent(value);
  } catch {
    return null;
  }

  v = v.trim();

  v = v.replace(/^["']+|["']+$/g, '');

  if (!v) return null;

  if (normalize) v = normalize(v);

  return validate(v) ? v : null;
};

export const sanitizeRedirect = (value) =>
  sanitizeParam(value, {
    normalize: (v) => (v.startsWith('/') ? v : `/${v}`),
    validate: (v) => /^\/[a-zA-Z0-9/_-]*$/.test(v),
  });

export const sanitizeToken = (value) =>
  sanitizeParam(value, {
    validate: (v) => /^[a-zA-Z0-9._-]+$/.test(v),
  });
